import { isBranchConstrained } from "../../../../auth/sessionAccess.ts";
import React from "react";
import { findAllAssistance, findeDuplicateDeviceCheck } from "../../../../services/assistanceCheck.service.ts";
import { useAppSettings } from "../../../../hooks/useAppSettings.tsx";
import Layout from "../../../Layout.tsx";
import Title from "../../../Title.tsx";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/index.ts";
import {
  setLoading,
  setRecords,
  setTotal,
} from "../../../../store/slices/duplicateDevicesSlice.ts";
import { notification } from "../../../../utils/Notifications.tsx";
import { useParams } from "react-router-dom";
import { findAllSchedulesByBranch } from "../../../../services/branchSchedule.service.ts";
import FilterDuplicateDevices from "./FilterDuplicateDevices.tsx";
import TableDuplicateDevice from "./TableDuplicateDevice.tsx";
import PaginationDuplicateDevice from "./PaginationDuplicateDevice.tsx";
import { readBranches } from "../../../../services/branch.service.ts";
import Branch from "../../../../models/Branch.ts";
import CustomSelectField from "../../../formik/CustomSelectField.tsx";
import { useFormik } from "formik";

const ReportDuplicateDevices = () => {
  useAppSettings();
  const { user } = useSelector((state: RootState) => state.auth);
  const { id: ipParams } = useParams();
  
  const dispatch = useDispatch();
  const { page, limit, param, fetch, query, sortBy, defaultSort } = useSelector(
    (state: RootState) => state.duplicateDevice
  );
  const [branchs, setBranchs] = React.useState<any[]>([]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      branch: -99,
    },
    onSubmit: () => {
      fetchPuestos();
    },
  });

  const fetchBranches = async () => {
    try {
      const branches = await readBranches();
      setBranchs(branches);
      
      const defaultBranchId = isBranchConstrained(user) 
        ? Number(user.branchId) 
        : Number(ipParams);
      
      const branch = branches.find(
        (branch: Branch) => Number(branch.id) === defaultBranchId
      );
      
      if (branch) {
        await formik.setFieldValue("branch", branch.id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    fetchBranches();
  }, [user]);

  React.useEffect(() => {
    if (formik.values.branch !== -99) {
      fetchPuestos();
    }
  }, [page, limit, param, fetch, query, sortBy, defaultSort, formik.values.branch]);

  const fetchPuestos = async () => {
    const id = formik.values.branch !== -99 ? Number(formik.values.branch) : null;
    if (!id) return;

    dispatch(setLoading(true));
    try {
      if (!query.includes("dateStart")) {
        dispatch(setLoading(false));
        return;
      }
      const offset = page === 0 ? 0 : page * limit;
      let queryToSend =
        query +
        `&sort=${sortBy}&order=${defaultSort}&limit=${limit}&offset=${offset}`;
      console.log("QUERY TO SEND ", queryToSend);
      const response = await findeDuplicateDeviceCheck(id, queryToSend);
      console.log("QUERYYYY PARA DUPLICATE DEVICES ", response);
      dispatch(setRecords(response.records));
      dispatch(setTotal(response.total));
    } catch (error) {
      notification("Error", error.message, "danger");
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Layout>
      <Title
        baseTitle="Sucursales"
        basePath="/sucursales"
        activeTitle="ReportDuplicateDevicess"
        title="Resumen de registros"
      />
      <div className="tab-pane fade active show" id="Puestos">
        <div className="card border-0 m-4 p-4">
          <div className="d-flex flex-row w-100 justify-content-center align-items-end gap-2 mb-3">
            <div className="w-25">
              <CustomSelectField
                formik={formik}
                field="branch"
                list={branchs}
                label="Sucursal"
                disabled={isBranchConstrained(user)}
              />
            </div>
          </div>
        </div>
        <div className="card border-0 m-4">
          <div className="tab-content p-3">
            <FilterDuplicateDevices id={formik.values.branch !== -99 ? Number(formik.values.branch) : null} />
            <TableDuplicateDevice />
            <PaginationDuplicateDevice />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ReportDuplicateDevices;